<template>
  <div class="obligation" style="background: #f8f8f8; padding-bottom:60px; margin-top:30px; ">
    <div style="width: 1000px; margin:0 auto;">
      <h4>
        <span>社会责任</span>／Responsibility
      </h4>
      <p class="ation" style="padding:30px 0 0;">
       美菜积极服务于国家脱贫攻坚战略，实施了“美菜SOS精准扶贫全国采购计划”、最美菜公益基金、美菜SOS精准扶贫专区、“一村一品”扶贫活动等系列行动，形成了“美菜即扶贫、救急又救穷”的扶贫文化和“帮乡亲、扶产业、暖人心”三位一体的脱贫举措，扶贫成效十分显著，得到了各地政府、企业、农民合作社和种植大户的广泛认可。
      </p>
      <div style="margin-top:20px;">
        <img src="@/assets/images/new-img/company/responsibility_1.png" width="300px"/>
        <img style="margin-left:45px;" src="@/assets/images/new-img/company/responsibility_2.jpg"  width="300px"/>
        <img style="margin-left:45px;" src="@/assets/images/new-img/company/responsibility_3.jpg"  width="300px"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "responsibility",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.obligation {
  padding-top: 50px;
  h4 {
    margin: 0;
    padding: 0;
    font-size: 18px;
    text-align: center;
    span {
      font-size: 30px;
    }
  }
  .ation {
    color: #757575;
    padding: 22px 10px 5px 10px;
    line-height: 1.8;
  }
}
</style>